<div class="search-bar-container">
  <div class="search-bar">
    <input
      [(ngModel)]="filterText"
      type="text"
      placeholder="Pesquise por um EAN, nome, subtipo, laboratório ou classe terapêutica de um produto"
      (keyup.enter)="onFilterSearch()" />
    <div class="search-icon-container" (click)="onFilterSearch()">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>
  <button *ngIf="hasAccessToInsertProduct()" mat-flat-button class="add-btn" (click)="goToInsertProduct()">ADICIONAR PRODUTO</button>
</div>
<div class="filter-date-container">
  <mat-label id="label-modif">Modificados em:</mat-label>
  <span class="picker-container">
    <mat-form-field class="date-field">
      <input [(ngModel)]="startAt" matInput placeholder="Data Inicial" required [textMask]="{ mask: dateMaskInput, guide: false }" />
    </mat-form-field>

    <mat-form-field>
      <input [(ngModel)]="endAt" matInput placeholder="Data Final" required [textMask]="{ mask: dateMaskInput, guide: false }" />
    </mat-form-field>
  </span>

  <mat-checkbox labelPosition="after" [(ngModel)]="pendingProducts" (change)="onFilterSearch()">Produtos Pendentes de Verificação.</mat-checkbox>
</div>

<div class="mat-table-container">
  <p *ngIf="!hasProducts()">Nenhum produto encontrado.</p>
  <table *ngIf="hasProducts()" mat-table [dataSource]="getProducts()" matSort matSortActive="created" matSortDisableClear matSortDirection="desc">
    <ng-container matColumnDef="ean">
      <th mat-header-cell *matHeaderCellDef>EAN</th>
      <td mat-cell *matCellDef="let element" class="ean-cell">
        {{ element.getEan1() }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let element" class="name-cell">
        {{ element.getProductName() }}
      </td>
    </ng-container>
    <ng-container matColumnDef="presentation">
      <th mat-header-cell *matHeaderCellDef>Apresentação</th>
      <td mat-cell *matCellDef="let element" class="presentation-cell">
        {{ element.getPresentation() }}
      </td>
    </ng-container>
    <ng-container matColumnDef="laboratory">
      <th mat-header-cell *matHeaderCellDef>Laboratório</th>
      <td mat-cell *matCellDef="let element" class="laboratory-cell">
        {{ element.getLaboratory() }}
      </td>
    </ng-container>
    <ng-container matColumnDef="productType">
      <th mat-header-cell *matHeaderCellDef>Tipo de Produto</th>
      <td mat-cell *matCellDef="let element">
        {{ element.getProductType().getValue() }}
      </td>
    </ng-container>
    <ng-container matColumnDef="productSubType">
      <th mat-header-cell *matHeaderCellDef>Sub Tipo de Produto</th>
      <td mat-cell *matCellDef="let element">
        {{ element.getProductSubType().getValue() }}
      </td>
    </ng-container>
    <ng-container matColumnDef="modified">
      <th mat-header-cell *matHeaderCellDef>Data de Modificação</th>
      <td mat-cell *matCellDef="let element">
        {{ element.getModified() | date : "dd/MM/yyyy HH:mm" }}
      </td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef>
        {{ hasAccessToEditProduct() ? "Editar" : "Visualizar" }}
      </th>
      <td mat-cell *matCellDef="let element" class="edit-cell">
        <mat-icon class="edit-icon" *ngIf="hasAccessToEditProduct()" (click)="goEditProduct(element)">edit</mat-icon>
        <mat-icon *ngIf="!hasAccessToEditProduct()" (click)="goEditProduct(element)">visibility</mat-icon>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator *ngIf="hasProducts()" [length]="getProductsLenth()" [pageSizeOptions]="[10, 50, 100]" (page)="onPaginatorChange($event)"></mat-paginator>
</div>
